import FaceCardFormatterDeck from "../FaceCardFormatterDeck";
import ColorsFolderIMG from "../../assets/FolderIcons/ColorsFolderIMG.png";
import NumbersFolderIMG from "../../assets/FolderIcons/NumbersFolderIMG.png";
import EmotionsFolderIMG from "../../assets/FolderIcons/EmotionsFolderIMG.png";
import TimeFolderIMG from "../../assets/FolderIcons/TimeFolderIMG.png";
import PronounsFolderIMG from "../../assets/FolderIcons/PronounsFolderIMG.png";
import RelationshipsFolderIMG from "../../assets/FolderIcons/RelationshipsFolderIMG.png";
import FamilyFolderIMG from "../../assets/FolderIcons/FamilyFolderIMG.png";
import NatureFolderIMG from "../../assets/FolderIcons/NatureFolderIMG.png";
import SchoolFolderIMG from "../../assets/FolderIcons/SchoolFolderIMG.png";
import WorkFolderIMG from "../../assets/FolderIcons/WorkFolderIMG.png";
import HomeFolderIMG from "../../assets/FolderIcons/HomeFolderIMG.png";
import ClothingFolderIMG from "../../assets/FolderIcons/ClothingFolderIMG.png";
import ActivitiesFolderIMG from "../../assets/FolderIcons/ActivitiesFolderIMG.png";
import TravelFolderIMG from "../../assets/FolderIcons/TravelFolderIMG.png";
import CountriesFolderIMG from "../../assets/FolderIcons/CountriesFolderIMG.png";
import PlacesFolderIMG from "../../assets/FolderIcons/PlacesFolderIMG.png";
import HealthFolderIMG from "../../assets/FolderIcons/HealthFolderIMG.png";

export const PeopleDeckFace = [

        {
        id: "pronouns",
        Title: "Pronouns",
        Description: "Learn how to talk about yourself & others!",
        Difficulty: "Beginner 2",
        Image: PronounsFolderIMG,
        Link: "/PronounsNav",
        cssId: "pronounsID"
    },
    {
        id: "emotions",
        Title: "Emotions",
        Description: "Learn how to describe how you feel!",
        Difficulty: "Beginner 2",
        Image: EmotionsFolderIMG,
        Link: "/EmotionsNav",
        cssId: "familyID"
    },
        {
        id: "family",
        Title: "Family",
        Description: "Learn how to talk about family!",
        Difficulty: "Beginner 2",
        Image: FamilyFolderIMG,
        Link: "/FamilyNav",
        cssId: "familyID"
    },
        {
        id: "relationships",
        Title: "Relationships",
        Description: "Learn how to talk about relationships between people!",
        Difficulty: "Beginner 2",
        Image: RelationshipsFolderIMG,
        Link: "/RelationshipsNav",
        cssId: "relationshipsID"
    },




];



export const BasicsDeckFace = [

    {
        id: "colors",
        Title: "Colors",
        Description: "Learn basic colors like red and blue!",
        Difficulty: "Beginner 2",
        Image: ColorsFolderIMG,
        Link: "/ColorsNav",
        cssId: "colorsID"

    },

        {
        id: "numbers",
        Title: "Numbers",
        Description: "Learn how to count in Korean!",
        Difficulty: "Beginner 2",
        Image: NumbersFolderIMG,
        Link: "/NumbersNav",
        cssId: "numbers-colorsID"

    },

    {
        id: "time",
        Title: "Time",
        Description: "Learn how to decribe time in Korean!",
        Difficulty: "Beginner 2",
        Image: TimeFolderIMG,
        Link: "/TimeNav",
        cssId: "timeID"

    },
]


export const EverydayDeckFace = [

        {
        id: "school",
        Title: "School",
        Description: "Learn how to talk about school!",
        Difficulty: "Beginner 2",
        Image: SchoolFolderIMG,
        Link: "/SchoolNav",
        cssId: "schoolID",
        comingSoon: true
    },
    {
        id: "work",
        Title: "Work",
        Description: "Learn how to talk about work!",
        Difficulty: "Beginner 2",
        Image: WorkFolderIMG,
        Link: "/WorkNav",
        cssId: "workID",
        comingSoon: true
    },
        {
        id: "home",
        Title: "Home",
        Description: "Learn how to talk about your home!",
        Difficulty: "Beginner 2",
        Image: HomeFolderIMG,
        Link: "/HomeNav",
        cssId: "homeID",
        comingSoon: true
        //bedroom, kitchen, backyard, living room, bathroom, washroom
    },
                    {
        id: "travel",
        Title: "Travel",
        Description: "Learn words to use on your travels!",
        Difficulty: "Beginner 2",
        Image: TravelFolderIMG,
        Link: "/TravelNav",
        cssId: "travelID",
        comingSoon: true
    }, //transportation (like busses, planes...)
    {
        id: "clothing",
        Title: "Clothing",
        Description: "Learn how to talk about clothing!",
        Difficulty: "Beginner 2",
        Image: ClothingFolderIMG,
        Link: "/ClothingNav",
        cssId: "clothingID",
        comingSoon: true
    },


            {
        id: "activities",
        Title: "Activities",
        Description: "Learn verbs, hobbies, and more!",
        Difficulty: "Beginner 2",
        Image: ActivitiesFolderIMG,
        Link: "/ActivitiesNav",
        cssId: "actvitiesID",
        comingSoon: true
    }, //hobbies, shopping, intrests, sports, verbs basic, verbs complex, chores

            {
        id: "health",
        Title: "Health",
        Description: "Learn to talk about wellness, sickness, and more!",
        Difficulty: "Beginner 2",
        Image: HealthFolderIMG,
        Link: "/HealthNav",
        cssId: "HealthID",
        comingSoon: true
    },

]


export const WorldDeckFace = [

    
    {
        id: "nature",
        Title: "Nature",
        Description: "Learn how to take about nature!",
        Difficulty: "Beginner 2",
        Image: NatureFolderIMG,
        Link: "/NatureNav",
        cssId: "natureID",
        comingSoon: true
    },//animals, sea life, plants, land features (landmarks?), planets, insects, Weather
    
    {
        id: "countries",
        Title: "Countries",
        Description: "Learn how to idenify countries!",
        Difficulty: "Beginner 2",
        Image: CountriesFolderIMG,
        Link: "/CountriesNav",
        cssId: "natureID",
        comingSoon: true
    }, //country names, nationalities

        {
        id: "places",
        Title: "Places",
        Description: "Learn the names of different places!",
        Difficulty: "Beginner 2",
        Image: PlacesFolderIMG,
        Link: "/PlacesNav",
        cssId: "natureID",
        comingSoon: true
    },  //places: buildings, store types
]

    //Export the fully formatted card when called
    export function BasicsDeckFaceCard() {
        return (
    
            <FaceCardFormatterDeck FaceCard={BasicsDeckFace}/>
        
        )
    
    }

        //Export the fully formatted card when called
    export function PeopleDeckFaceCard() {
        return (
    
            <FaceCardFormatterDeck FaceCard={PeopleDeckFace}/>
        
        )
    
    }

            //Export the fully formatted card when called
    export function WorldDeckFaceCard() {
        return (
    
            <FaceCardFormatterDeck FaceCard={WorldDeckFace}/>
        
        )
    
    }